module.exports = __webpack_public_path__ + "static/media/ReleaseNotes.8e28273f.txt";